import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { PageCarousel } from './components/PageCarousel';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
// import { PurchaseNotifications } from './components/PurchaseNotifications'
// Mount <PurchaseNotifications /> again once data/recentPurchases.ts is fed by real orders.

export function App() {
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3mjq45l4rr2xp">
      <MetaPixel data-id="element-1" data-mp="3relumgucxi8p" />
      <main data-id="element-2" data-mp="5otf64sd496">
        <Hero data-id="element-3" data-mp="6hpnd64cbd2" />
        <SocialProofBar data-id="element-4" data-mp="4wxfu7a14id" />
        <PainGrid data-id="element-5" data-mp="56ntiw8hdol" />
        <ProductReveal data-id="element-6" data-mp="7suzhf7pr6a" />
        <Tomes data-id="element-7" data-mp="2zld4hgdhhrep" />
        <PageCarousel data-id="element-8" data-mp="2zlv8x0aavbxp" />
        <Bonuses data-id="element-9" data-mp="2zmo557bmuj1l" />
        <ValueStack data-id="element-10" data-mp="2zn6actg9w7ln" />
        <Urgency data-id="element-11" data-mp="33mow1rfx4mpj" />
        <Pricing data-id="element-12" data-mp="33m5cy7ej7s9x" />
        <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="white" data-id="element-13" data-mp="33nq4rp9gox43" />
        <Guarantee data-id="element-14" data-mp="38nuqbtp88i16" />
        <Faq data-id="element-15" data-mp="3dkuw03i5zirr" />
        <Testimonials testimonials={moreTestimonials} title="Works alongside your club" subtitle="Club coaches use it to turn the drills they already have into a full practice." background="cream" data-id="element-16" data-mp="3dle2mo2d6kqh" />
        <CostOfInaction data-id="element-17" data-mp="ssspumptca9c" />
        <Close data-id="element-18" data-mp="swgm3tmn7arr" />
      </main>
      <Footer data-id="element-19" data-mp="35yngfn0fdzc" />
    </div>;
}